import {ChangeEvent, forwardRef, useCallback} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../Icon/Icon';
import {IconType} from '../Icon/IconType.enum';
import {InputProps} from './InputProps.interface';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      value,
      disabled,
      onChange,
      type,
      onClickRemoveButton,
      isMobile,
      className,
      ...props
    },
    ref
  ) => {
    // input type이 number일 때, 한글입력을 막기 위해 정규식으로 숫자만 들어오는지 확인합니다.
    const onChangeInput = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        if (type === 'number' && onChange) {
          const testNativeData = NUMBER_REGEXP.test(
            (e.nativeEvent as InputEvent).data as string
          );
          const testTargetValue = NUMBER_REGEXP.test(e.target.value);
          if (
            testNativeData ||
            testTargetValue ||
            (e.nativeEvent as InputEvent).data === null
          ) {
            onChange(e);
            return null;
          }
        } else if (onChange) {
          onChange(e);
        }
      },
      [onChange, type]
    );
    return (
      <div className="flex w-full items-center">
        <input
          className={twMerge(
            'font-medium1 flex-1 bg-transparent text-theme-solid-100 outline-hidden placeholder:text-theme-solid-40 disabled:text-theme-solid-20',
            !isMobile && 'font-small1',
            className
          )}
          ref={ref}
          value={value}
          disabled={disabled}
          onChange={onChangeInput}
          type={type}
          {...props}
          // size의 기본 내장값이 20이기 때문에 20글자를 보여줄 수 있는 너비로 브라우저에서 min-width를 알아서 잡아버리므로 size를 1로 수정합니다
          size={1}
        />
        {onClickRemoveButton && value && (
          <button>
            <Icon
              className={twMerge(
                'ml-4pxr box-content shrink-0 cursor-pointer overflow-hidden bg-cover bg-no-repeat',
                disabled && 'opacity-40'
              )}
              ariaHidden={false}
              type={IconType.InputboxDelete}
              disabled={disabled}
              onClick={disabled ? undefined : onClickRemoveButton}
            />
          </button>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
const NUMBER_REGEXP = /\d/g;
